import { ElementRef, EventEmitter, SimpleChanges } from '@angular/core';
import { MessageService } from '../../message/message.service';
import { SessionStorageService } from 'ngx-webstorage';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RatingService } from '../../rating/rating.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OfflineMessageService } from '../../session/offline-message/offline-message.service';
import { UserService } from '../../../core/user/user.service';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { TRANSLATED_LOGINS } from '../../../app.constants';
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from '../../../core/auth/account.service';
import { CustomerCareInfoModalComponent } from '../../session/offline-message/customer-care-info-modal.component';
import moment from 'moment';
import { SessionService } from '../../session/session.service';
import { BaseComponent } from '../../../shared/base.component';
import { ConversationnService } from '../../conversationn/conversationn.service';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../../ng-jhipster/service";
import * as i2 from "../../message/message.service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../rating/rating.service";
import * as i5 from "@angular/router";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "../../session/offline-message/offline-message.service";
import * as i8 from "../../../core/user/user.service";
import * as i9 from "../../../core/tracker/tracker.service";
import * as i10 from "@ngx-translate/core";
import * as i11 from "../../../core/auth/account.service";
import * as i12 from "../../session/session.service";
import * as i13 from "../../conversationn/conversationn.service";
import * as i14 from "@angular/common";
import * as i15 from "../../../shared/alert/alert.component";
import * as i16 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i17 from "../../../shared/auth/has-any-authority.directive";
import * as i18 from "@angular/material/form-field";
import * as i19 from "@angular/material/input";
import * as i20 from "@angular/forms";
import * as i21 from "../../../shared/auto-direction-switch/auto-direction-switch/auto-direction-switch.component";
import * as i22 from "@fortawesome/angular-fontawesome";
import * as i23 from "../offline-message/search-keyword.pipe";
const _c0 = ["activeSessionAlertModal"];
const _c1 = ["conversationListAlertModal"];
function ConversationListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "h3", 5);
    i0.ɵɵelement(2, "p", 6);
    i0.ɵɵelementEnd();
} }
function ConversationListComponent_div_1_mat_form_field_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 19);
    i0.ɵɵelementStart(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 20);
    i0.ɵɵlistener("ngModelChange", function ConversationListComponent_div_1_mat_form_field_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.searchText = $event; });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "coachManagement.search"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 5, "coachManagement.search"));
    i0.ɵɵproperty("ngModel", ctx_r6.searchText);
} }
function ConversationListComponent_div_1_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "auto-direction-switch", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", c_r12.lastMessage == null ? null : c_r12.lastMessage.message, i0.ɵɵsanitizeHtml);
} }
function ConversationListComponent_div_1_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 38);
} if (rf & 2) {
    const c_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", c_r12.lastMessage == null ? null : c_r12.lastMessage.message, i0.ɵɵsanitizeHtml);
} }
function ConversationListComponent_div_1_div_4_div_11_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 40);
} if (rf & 2) {
    const c_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("jhiTranslate", c_r12.lastMessage == null ? null : c_r12.lastMessage.message);
} }
function ConversationListComponent_div_1_div_4_div_11_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.session.user.login);
} }
function ConversationListComponent_div_1_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ConversationListComponent_div_1_div_4_div_11_span_1_Template, 1, 1, "span", 39);
    i0.ɵɵtemplate(2, ConversationListComponent_div_1_div_4_div_11_span_2_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (c_r12.lastMessage == null ? null : c_r12.lastMessage.message) !== "inukaNgApp.session.actionPlanWasSharedWith");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (c_r12.lastMessage == null ? null : c_r12.lastMessage.message) === "inukaNgApp.session.actionPlanWasSharedWith");
} }
function ConversationListComponent_div_1_div_4_fa_icon_15_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 41);
    i0.ɵɵlistener("click", function ConversationListComponent_div_1_div_4_fa_icon_15_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r28); const c_r12 = i0.ɵɵnextContext().$implicit; const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.flagConversation(c_r12); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("color", ctx_r17.getFlagColor(c_r12));
} }
function ConversationListComponent_div_1_div_4_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", c_r12.unreadCount ? "d-flex" : "d-hidden");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(c_r12.unreadCount);
} }
function ConversationListComponent_div_1_div_4_hr_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 43);
} }
const _c2 = function (a0) { return { "background-color": a0 }; };
function ConversationListComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "div", 23);
    i0.ɵɵelement(3, "span", 24);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵlistener("click", function ConversationListComponent_div_1_div_4_Template_div_click_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r32); const c_r12 = restoredCtx.$implicit; const i_r13 = restoredCtx.index; const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.emitItem(c_r12, i_r13); });
    i0.ɵɵelementStart(6, "h5");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 26);
    i0.ɵɵtemplate(9, ConversationListComponent_div_1_div_4_div_9_Template, 2, 1, "div", 27);
    i0.ɵɵtemplate(10, ConversationListComponent_div_1_div_4_div_10_Template, 1, 1, "div", 28);
    i0.ɵɵtemplate(11, ConversationListComponent_div_1_div_4_div_11_Template, 3, 2, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 30);
    i0.ɵɵlistener("click", function ConversationListComponent_div_1_div_4_Template_div_click_12_listener() { const restoredCtx = i0.ɵɵrestoreView(_r32); const c_r12 = restoredCtx.$implicit; const i_r13 = restoredCtx.index; const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.emitItem(c_r12, i_r13); });
    i0.ɵɵelementStart(13, "div", 31);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ConversationListComponent_div_1_div_4_fa_icon_15_Template, 1, 2, "fa-icon", 32);
    i0.ɵɵtemplate(16, ConversationListComponent_div_1_div_4_div_16_Template, 3, 2, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "span", 34);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, ConversationListComponent_div_1_div_4_hr_19_Template, 1, 0, "hr", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r12 = ctx.$implicit;
    const i_r13 = ctx.index;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(19, _c2, ctx_r7.setBackgroundColor(i_r13)));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("background", ctx_r7.getUnreadIndicatorColor(c_r12, i_r13));
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 15, "inukaNgApp.offlineMessage.markRead"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r7.peerLogin(c_r12));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (c_r12.lastMessage == null ? null : c_r12.lastMessage.type) === "text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (c_r12.lastMessage == null ? null : c_r12.lastMessage.type) === "htmlNotification");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (c_r12.lastMessage == null ? null : c_r12.lastMessage.type) === "textNotification");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.messageSendDate(c_r12));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.isCustomerCare);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.isCustomerCare);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("background", ctx_r7.getFlaggedIndicatorColor(c_r12, i_r13));
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(18, 17, "inukaNgApp.offlineMessage.markRead"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r7.selectedRow === i_r13 || ctx_r7.selectedRow - 1 === i_r13 || i_r13 === ctx_r7.conversations.length - 1));
} }
function ConversationListComponent_div_1_li_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 16);
    i0.ɵɵelementStart(1, "a", 17);
    i0.ɵɵtext(2, "...");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ConversationListComponent_div_1_li_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 16);
    i0.ɵɵelementStart(1, "a", 17);
    i0.ɵɵtext(2, "...");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c3 = function () { return ["ROLE_CUSTOMER_CARE", "ROLE_COACH"]; };
function ConversationListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵtemplate(2, ConversationListComponent_div_1_mat_form_field_2_Template, 6, 7, "mat-form-field", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵtemplate(4, ConversationListComponent_div_1_div_4_Template, 20, 21, "div", 11);
    i0.ɵɵpipe(5, "slice");
    i0.ɵɵpipe(6, "searchFilter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 12);
    i0.ɵɵelementStart(8, "div", 13);
    i0.ɵɵelementStart(9, "ul");
    i0.ɵɵelementStart(10, "li", 14);
    i0.ɵɵlistener("click", function ConversationListComponent_div_1_Template_li_click_10_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.before(); });
    i0.ɵɵelementStart(11, "a");
    i0.ɵɵtext(12, "\u00AB");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, ConversationListComponent_div_1_li_13_Template, 3, 0, "li", 15);
    i0.ɵɵelementStart(14, "li", 16);
    i0.ɵɵelementStart(15, "a", 17);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, ConversationListComponent_div_1_li_17_Template, 3, 0, "li", 15);
    i0.ɵɵelementStart(18, "li", 18);
    i0.ɵɵlistener("click", function ConversationListComponent_div_1_Template_li_click_18_listener() { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.next(); });
    i0.ɵɵelementStart(19, "a");
    i0.ɵɵtext(20, "\u00BB");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(14, _c3));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(5, 7, i0.ɵɵpipeBind2(6, 11, ctx_r1.conversations, ctx_r1.searchText), ctx_r1.getStart(), ctx_r1.getEnd()));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", ctx_r1.currentPage === 0 ? "paginationjs-prev disabled" : "paginationjs-prev");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.currentPage > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.currentPage + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.numberOfPages > ctx_r1.currentPage + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r1.currentPage + 1 === ctx_r1.numberOfPages ? "paginationjs-next disabled" : "paginationjs-next");
} }
const _c4 = function (a0) { return { coach: a0 }; };
function ConversationListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "h4", 45);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "span", 46);
    i0.ɵɵelement(4, "span", 47);
    i0.ɵɵelement(5, "br");
    i0.ɵɵelement(6, "br");
    i0.ɵɵelement(7, "span", 48);
    i0.ɵɵelement(8, "br");
    i0.ɵɵelement(9, "br");
    i0.ɵɵelementStart(10, "div", 49);
    i0.ɵɵelementStart(11, "button", 50);
    i0.ɵɵlistener("click", function ConversationListComponent_ng_template_2_Template_button_click_11_listener() { const restoredCtx = i0.ɵɵrestoreView(_r39); const modal_r37 = restoredCtx.$implicit; return modal_r37.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 51);
    i0.ɵɵlistener("click", function ConversationListComponent_ng_template_2_Template_button_click_12_listener() { const restoredCtx = i0.ɵɵrestoreView(_r39); const modal_r37 = restoredCtx.$implicit; return modal_r37.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c4, ctx_r3.sessions[0].coach.login));
} }
function ConversationListComponent_ng_template_4_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h3", 55);
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r42.errorMessage);
} }
function ConversationListComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtemplate(1, ConversationListComponent_ng_template_4_h3_1_Template, 1, 1, "h3", 53);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "div", 49);
    i0.ɵɵelementStart(5, "button", 54);
    i0.ɵɵlistener("click", function ConversationListComponent_ng_template_4_Template_button_click_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r44); const modal_r41 = restoredCtx.$implicit; return modal_r41.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.errorMessage);
} }
const PAGE_LENGTH = 8;
export function convertToMessageSummary(m) {
    let message = "";
    if (m.message != null) {
        if (m.type === 'htmlNotification') {
            message = m.message.replace(/<.+?>/g, " ");
        }
        if (m.type === 'text' || m.type === 'htmlNotification') {
            message = m.message.length > 30 ? m.message.substring(0, 30) + "..." : m.message;
        }
        else {
            message = m.message;
        }
    }
    return message;
}
export class ConversationListComponent extends BaseComponent {
    constructor(eventManager, messageService, sessionStorage, ratingService, alertService, router, modalService, offlineMessageService, userService, trackerService, translateService, accountService, route, sessionService, conversationService) {
        super(sessionStorage, modalService);
        this.eventManager = eventManager;
        this.messageService = messageService;
        this.sessionStorage = sessionStorage;
        this.ratingService = ratingService;
        this.alertService = alertService;
        this.router = router;
        this.modalService = modalService;
        this.offlineMessageService = offlineMessageService;
        this.userService = userService;
        this.trackerService = trackerService;
        this.translateService = translateService;
        this.accountService = accountService;
        this.route = route;
        this.sessionService = sessionService;
        this.conversationService = conversationService;
        this.isHidden = true;
        this.conversations = [];
        this.modalOptions = { windowClass: 'modal-window', size: 'md' };
        // possible values: "OfflineMessageUiComponent", "ScheduleSessionComponent"
        this.visibleComponent = "OfflineMessageUiComponent";
        this.sessions = [];
        this.selectedRow = 0;
        this.selectedConv = new EventEmitter();
        // fakeCoaches = ["Customer Care", "Notification(s)"];
        this.fakeCoaches = ["Customer Care"];
        this.sessionId = this.route.snapshot.params["sessionId"];
    }
    ngOnInit() {
        var _a;
        this.accountService.getAuthenticationState().subscribe(account => { this.currentAccount = account; });
        this.isCustomerCare = this.accountService.isCustomerCare();
        this.isCoach = this.accountService.isCoach();
        this.getConversations();
        console.log("InboxComponent.ngOnInit");
        this.currentPage = 0;
        this.first = true;
        this.mobile = true;
        this.users = [];
        console.log("DEBUG: " + this.sessionId);
        this.messageService.setCurrentConversation(this.selectedConversation);
        this.offlineMessageService.setPage.subscribe(() => { this.goFirstPage(); });
        this.subscribeToWebsocket();
        if (!this.accountService.isCoach()) {
            this.sessionService.activeSession().subscribe((res) => {
                this.sessions = res.body || [];
                if (this.sessions.length > 0) {
                    this.modalService.open(this.activeSessionAlertModal, { backdrop: 'static' });
                }
            }, (err) => {
                console.log(err);
            });
        }
        if (this.conversations && this.conversations.length > 0) {
            this.conversations.find(c => { var _a, _b; return c.user.id === ((_a = this.scrolledToBottom) === null || _a === void 0 ? void 0 : _a.userId) && c.coach.id === ((_b = this.scrolledToBottom) === null || _b === void 0 ? void 0 : _b.coachId); }).unreadCount = (_a = this.scrolledToBottom) === null || _a === void 0 ? void 0 : _a.unreadMessageCount;
        }
    }
    ngOnChanges(changes) {
        var _a;
        super.ngOnChanges(changes);
        if (this.conversations && this.conversations.length > 0) {
            this.conversations.find(c => { var _a, _b; return c.user.id === ((_a = this.scrolledToBottom) === null || _a === void 0 ? void 0 : _a.userId) && c.coach.id === ((_b = this.scrolledToBottom) === null || _b === void 0 ? void 0 : _b.coachId); }).unreadCount = (_a = this.scrolledToBottom) === null || _a === void 0 ? void 0 : _a.unreadMessageCount;
        }
    }
    subscribeToWebsocket() {
        this.subscription = this.trackerService.listenerSubject.subscribe(value => {
            const message = value['body'];
            const type = value['type'];
            if (type === 'TYPING') {
                console.log('peer is typing');
                // this.typingMessage = message.senderName + ' is typing ';
                // setTimeout(() => {
                //   this.typingMessage = '';
                // }, 3000);
            }
            else if (type === 'MESSAGE_SEEN') {
                console.log(type);
            }
            else if (type === 'OFFLINE_MESSAGE_RECEIVED' || type === 'SESSION_MESSAGE') {
                console.log(message);
                if (message.receiverId === this.currentAccount.id) {
                    let conversation = this.conversations.find(c => c.id === message.convId);
                    conversation.lastMessageOfOther = message;
                    this.toggleUnread(conversation, true);
                }
                this.messageReceived(message);
            }
            else {
                console.log('Ignoring ' + type + ' message');
            }
        });
    }
    selectConversation(c) {
        if (c) {
            this.selectedConversation = c;
            this.messageService.setCurrentConversation(c);
            if (this.selectedConversation.lastMessageOfOther && !this.toggling)
                this.selectedConversation.lastMessageOfOther.status = 'DISPLAYED';
            this.selectedUser = c.user;
            this.isHidden = false;
            this.visibleComponent = "OfflineMessageUiComponent";
            this.messageToBeReplied = null;
            this.offlineMessageService.getConversationInfo(this.selectedConversation).subscribe(sc => {
                this.selectedConversation = sc;
                console.log(this.selectedConversation);
                this.selectedConv.emit(this.selectedConversation);
                this.eventManager.broadcast({ name: 'selectedConversationChanged', content: this.selectedConversation.user.id });
                this.userService.findAuthoritiesById(this.selectedConversation.coach.id).subscribe(res => {
                    console.log(res);
                    this.selectedConversation.coach.authorities = res;
                    if (this.currentAccount.authorities.includes('ROLE_USER')) {
                        if (this.selectedConversation.coach.authorities.includes('ROLE_CUSTOMER_CARE')) {
                            this.canBookSession = this.selectedConversation.lastEndedSession !== null && this.selectedConversation.lastEndedSession !== undefined;
                        }
                        else {
                            this.canBookSession = true;
                        }
                    }
                    else if (this.currentAccount.authorities.includes('ROLE_COACH')) {
                        this.canBookSession = this.selectedConversation.coach.login !== 'Notification(s)';
                    }
                    else
                        this.canBookSession = this.currentAccount.authorities.includes('ROLE_CUSTOMER_CARE');
                    console.log(this.canBookSession);
                });
            });
        }
    }
    goBackToContacts() { this.isHidden = true; }
    getMessages(a) {
        console.log(a);
        this.temp = [];
    }
    bookSessionChanging(isCoach) {
        this.visibleComponent = "ScheduleSessionComponent";
        this.isCoach = isCoach;
    }
    messageSent(sort) {
        console.log("message sent: " + sort);
        this.bottomScroll = true;
    }
    messageReceived(message) {
        if (this.getConversationSubscription) {
            // If another getConversation request is in progress, wait for 1 second and retry
            // It prevents concurrent requests for getConversation that can leads to duplicate conversations
            setTimeout(() => {
                this.messageReceived(message);
            }, 1000);
            return;
        }
        message = Object.assign({}, message);
        let filteredConversation = this.conversations.filter(c => (c.user.id === message.senderId && c.coach.id === message.receiverId) ||
            (c.coach.id === message.senderId && c.user.id === message.receiverId));
        if (message.convId !== this.selectedConversation.id) {
            let updatedConversation = filteredConversation.find(c => c.id = message.convId);
            updatedConversation.unreadCount++;
        }
        if (filteredConversation[0] !== undefined) {
            filteredConversation[0].lastMessage = this.convertDate(message);
            filteredConversation[0].lastMessage.message = convertToMessageSummary(filteredConversation[0].lastMessage);
            this.isCustomerCare ? this.sortConversationsByToggle(message.convId, message.senderId) : this.sortConversationsByDates(this.conversations);
        }
        else {
            console.log("message is undefined.");
            let peer = this.getPeer(message.senderId, message.receiverId);
            this.getConversationSubscription = this.offlineMessageService.getConversation(peer).subscribe((res) => {
                res.lastMessage = this.convertDate(message);
                res.lastMessage.message = convertToMessageSummary(res.lastMessage);
                this.conversations.push(res);
                this.isCustomerCare ? this.sortConversationsByToggle(message.convId, message.senderId) : this.sortConversationsByDates(this.conversations);
            }, () => {
            }, () => {
                // clear the subscription to be used for the other messages
                this.getConversationSubscription = null;
            });
        }
    }
    repliedMessage(message) {
        this.messageToBeReplied = message;
        console.log(this.messageToBeReplied);
    }
    sortConversationsByToggle(conversationId, senderId) {
        var _a;
        if (((_a = this.conversations) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (conversationId != null) {
                let currentConversation = this.conversations.find(c => c.id === conversationId);
                console.log(currentConversation);
                let index = this.conversations.indexOf(currentConversation);
                this.conversations.splice(index, 1);
                this.conversations.splice(0, 0, currentConversation);
                if (senderId === this.currentAccount.id)
                    this.selectedRow = 0;
            }
            else {
                this.conversations.sort((c1, c2) => {
                    let aLastMessageOfOther = c1.lastMessageOfOther;
                    let bLastMessageOfOther = c2.lastMessageOfOther;
                    if (aLastMessageOfOther === null)
                        return 1;
                    else if (bLastMessageOfOther === null)
                        return -1;
                    if (aLastMessageOfOther.createDate < bLastMessageOfOther.createDate)
                        return 1;
                    else if (aLastMessageOfOther.createDate > bLastMessageOfOther.createDate)
                        return -1;
                    let aLastMessage = c1.lastMessage;
                    let bLastMessage = c2.lastMessage;
                    if (aLastMessage === null)
                        return 1;
                    else if (bLastMessage === null)
                        return -1;
                    if (aLastMessage.createDate < bLastMessage.createDate)
                        return 1;
                    else if (aLastMessage.createDate > bLastMessage.createDate)
                        return -1;
                    return 0;
                });
            }
        }
        else {
            console.log('Conversation list is empty.');
        }
    }
    sortConversationsByDates(conversationList) {
        conversationList.sort((c1, c2) => {
            let aLastMessage = c1.lastMessage;
            let bLastMessage = c2.lastMessage;
            if (aLastMessage === null)
                return 1;
            else if (bLastMessage === null)
                return -1;
            if (aLastMessage.createDate < bLastMessage.createDate)
                return 1;
            else if (aLastMessage.createDate > bLastMessage.createDate)
                return -1;
            return 0;
        });
        return conversationList;
    }
    getPage(page) { this.currentPage = page; }
    getConversations() {
        this.offlineMessageService.getConversationsOfCurrentUser().subscribe(conversations => {
            for (const c of conversations) {
                if (!c.lastMessage)
                    continue;
                c.lastMessage.message = convertToMessageSummary(c.lastMessage);
            }
            this.conversations = conversations.sort((c1, c2) => c1.flagged === true && c2.flagged === false ? -1 : 1);
            console.log(this.conversations);
            this.eventManager.broadcast({ name: 'conversationListRetrieved', content: this.conversations.length });
            if (this.conversations != null) {
                // this.isCustomerCare ? this.sortConversationsByToggle() : this.sortConversationsByDates(this.conversations);
                if (this.isCoach)
                    this.sortConversationsByDates(this.conversations);
                this.selectConversationWithCCare = this.route.snapshot.params.conversation;
                if (this.selectConversationWithCCare === 'customer-care') {
                    this.userService.findCustomerCareIdByRegion(conversations[0].user.region.toString()).subscribe(customerCareId => {
                        let index = 0;
                        for (let conversation of this.conversations) {
                            if (customerCareId === conversation.coach.id) {
                                this.selectConversation(this.conversations[index]);
                                break;
                            }
                            index++;
                        }
                    });
                }
                else
                    this.selectConversation(this.conversations[0]);
                this.numberOfPages = Math.ceil(this.conversations.length / PAGE_LENGTH);
            }
            else {
                this.numberOfPages = 1;
            }
        });
    }
    next() {
        if (this.currentPage + 1 !== this.numberOfPages) {
            this.currentPage++;
            this.getPage(this.currentPage);
        }
    }
    before() {
        if (this.currentPage !== 0) {
            this.currentPage--;
            this.getPage(this.currentPage);
        }
    }
    go() {
        if (Number(this.goNumber) > 0 && Number(this.goNumber) <= this.roundedLength) {
            this.currentPage = Number(this.goNumber);
            this.getPage(Number(this.goNumber));
        }
    }
    isCurrentUser(userId) { return userId === this.sessionStorage.retrieve('id'); }
    peer(c) { return this.isCurrentUser(c.user.id) ? c.coach : c.user; }
    peerLogin(c) {
        let login = this.peer(c).login;
        return this.translatedUsername(login);
    }
    translatedUsername(login) {
        if (TRANSLATED_LOGINS.includes(login)) {
            login = this.translateService.instant("global." + login);
        }
        return login;
    }
    messageSendDate(c) { return c.lastMessage ? this.dateFormattedNumeric(c.lastMessage.createDate) : ""; }
    messageSendTime(c) { return c.lastMessage ? this.timeFormatted(c.lastMessage.createDate) : ""; }
    displayOfflineMessageUI() { return this.visibleComponent === "OfflineMessageUiComponent"; }
    displayScheduleSessionComponent() { return this.visibleComponent === "ScheduleSessionComponent"; }
    displayInfo(selectedConversation) {
        const modalRef = this.modalService.open(CustomerCareInfoModalComponent, this.modalOptions);
        modalRef.componentInstance.selectedConversation = selectedConversation;
    }
    getCoachForSessionSchedule() {
        if (this.selectedConversation.coach.authorities.includes('ROLE_CUSTOMER_CARE')) {
            return undefined;
        }
        else {
            return this.selectedConversation.coach;
        }
    }
    getStart() { return PAGE_LENGTH * this.currentPage; }
    getEnd() {
        return this.getStart() + PAGE_LENGTH;
    }
    convertDate(m) {
        m.createDate = moment(m.createDate);
        return m;
    }
    goFirstPage() {
        this.currentPage = 0;
    }
    displayCountdownModal() { }
    emitItem(c, i) {
        this.selectedRow = i;
        this.selectConversation(c);
    }
    setBackgroundColor(index) {
        return this.selectedRow === index ? '#F8F7F2' : 'white';
    }
    toggleUnread(c, isMessageReceived) {
        this.toggling = true;
        if (this.isRead(c.lastMessageOfOther)) {
            c.lastMessageOfOther.status = 'RECEIVED';
        }
        else {
            if (!isMessageReceived)
                c.lastMessageOfOther.status = 'DISPLAYED';
        }
        console.log(c.lastMessageOfOther);
        c.lastMessageOfOther = this.convertDate(c.lastMessageOfOther);
        c.lastMessageOfOther.message = convertToMessageSummary(c.lastMessageOfOther);
        this.offlineMessageService.updateMessageInfo(c.lastMessageOfOther).subscribe(um => {
            console.log(um);
            um.convId = c.id;
            this.sortConversationsByToggle(c.id, um.senderId);
            this.toggling = false;
        });
    }
    isRead(m) {
        return m.status === 'DISPLAYED';
    }
    getUnreadIndicatorColor(c, i) {
        if (this.isCustomerCare && c.lastMessageOfOther != null && !this.isRead(c.lastMessageOfOther))
            return '#44A38B';
        else
            return this.setBackgroundColor(i);
    }
    getFlaggedIndicatorColor(c, i) {
        if (this.isCustomerCare && c.flagged)
            return '#E0CA58';
        else
            return this.setBackgroundColor(i);
    }
    getFlagColor(c) {
        if (this.isCustomerCare && c.flagged)
            return '#E0CA58';
        else
            return '#0A4A3A';
    }
    flagConversation(c) {
        c.flagged = !c.flagged;
        let start = 0;
        if (!c.flagged)
            start = this.conversations.filter(ci => ci.flagged === true).length;
        let index = this.conversations.indexOf(c);
        this.conversationService.update(c).subscribe(res => {
            console.log(res.body);
            this.conversations.splice(index, 1);
            this.conversations.splice(start, 0, c);
        });
    }
    ngOnDestroy() {
        var _a, _b;
        super.ngOnDestroy();
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.getConversationSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
}
ConversationListComponent.ɵfac = function ConversationListComponent_Factory(t) { return new (t || ConversationListComponent)(i0.ɵɵdirectiveInject(i1.JhiEventManager), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.RatingService), i0.ɵɵdirectiveInject(i1.JhiAlertService), i0.ɵɵdirectiveInject(i5.Router), i0.ɵɵdirectiveInject(i6.NgbModal), i0.ɵɵdirectiveInject(i7.OfflineMessageService), i0.ɵɵdirectiveInject(i8.UserService), i0.ɵɵdirectiveInject(i9.TrackerService), i0.ɵɵdirectiveInject(i10.TranslateService), i0.ɵɵdirectiveInject(i11.AccountService), i0.ɵɵdirectiveInject(i5.ActivatedRoute), i0.ɵɵdirectiveInject(i12.SessionService), i0.ɵɵdirectiveInject(i13.ConversationnService)); };
ConversationListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConversationListComponent, selectors: [["conversation-list"]], viewQuery: function ConversationListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.activeSessionAlertModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.conversationListAlertModal = _t.first);
    } }, inputs: { scrolledToBottom: "scrolledToBottom" }, outputs: { selectedConv: "selectedConv" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 7, vars: 2, consts: [["class", "text-center p-4 mt-5", 4, "ngIf"], ["class", "m-0", "style", "overflow-y: hidden; height: 100%;", 4, "ngIf"], ["activeSessionAlertModal", ""], ["conversationListAlertModal", ""], [1, "text-center", "p-4", "mt-5"], ["jhiTranslate", "inukaNgApp.conversationn.noCoachees"], ["jhiTranslate", "inukaNgApp.conversationn.onceClientBooks"], [1, "m-0", 2, "overflow-y", "hidden", "height", "100%"], [1, "card", "form-card", 2, "border-radius", "0"], ["appearance", "outline", 4, "jhiHasAnyAuthority"], [2, "overflow-y", "scroll", "height", "calc(100% - 190px)", "width", "100%"], ["style", "font-family: 'Open Sans',serif", 4, "ngFor", "ngForOf"], [1, "paginationjs", "msb-reply", "px-1", "position-relative"], [1, "paginationjs-pages"], ["title", "Previous page", 1, "paginationjs-prev", 3, "ngClass", "click"], ["class", "paginationjs-page", 4, "ngIf"], [1, "paginationjs-page"], ["type", "button"], [3, "ngClass", "click"], ["appearance", "outline"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelChange"], [2, "font-family", "'Open Sans',serif"], ["role", "button", 1, "list-group-item", 3, "ngStyle"], [1, "d-flex", "justify-content-between"], [1, "indicator", "mr-1", 3, "title"], [2, "flex", "1", 3, "click"], [2, "font-size", "12px", "color", "#8A9D98"], ["style", "height: 18px;", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [1, "text-right", 2, "flex", "0 0 30%", 3, "click"], [2, "font-size", "12px", "color", "#8A9D98", "margin-bottom", "8px"], ["icon", "flag", 3, "color", "click", 4, "ngIf"], ["class", "justify-content-center align-items-center unread-count", 3, "ngClass", 4, "ngIf"], [1, "indicator", "ml-1", 3, "title"], ["style", "margin: 0!important;", 4, "ngIf"], [2, "height", "18px"], [3, "innerHtml"], [3, "innerHTML"], [3, "jhiTranslate", 4, "ngIf"], [3, "jhiTranslate"], ["icon", "flag", 3, "click"], [1, "justify-content-center", "align-items-center", "unread-count", 3, "ngClass"], [2, "margin", "0!important"], [1, "modal-body", 2, "background-color", "white", "overflow-wrap", "break-word", "border-radius", "0.3rem"], ["jhiTranslate", "sessionChat.started", 1, "modal-title", 2, "font-weight", "bold", "text-align", "center"], ["jhiTranslate", "sessionChat.readyToJoin", 3, "translateValues"], ["jhiTranslate", "sessionChat.notSeeMessages"], ["jhiTranslate", "sessionChat.toHomeScreen"], [1, "alert-box-actions", 2, "text-align", "center"], ["type", "button", "routerLink", "/index-user", "jhiTranslate", "sessionChat.home", 1, "btn", "btn-gradient-primary", "font-weight-bold", 2, "margin", "5px", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.cancel", 1, "btn", "btn-dark", 2, "margin", "5px", 3, "click"], [1, "modal-body", "olha-theme", "m-3"], ["class", "modal-title", 3, "jhiTranslate", 4, "ngIf"], ["type", "button", "jhiTranslate", "register.button.close", 1, "btn", "btn-primary", 2, "margin", "5px", 3, "click"], [1, "modal-title", 3, "jhiTranslate"]], template: function ConversationListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ConversationListComponent_div_0_Template, 3, 0, "div", 0);
        i0.ɵɵtemplate(1, ConversationListComponent_div_1_Template, 21, 15, "div", 1);
        i0.ɵɵtemplate(2, ConversationListComponent_ng_template_2_Template, 13, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, ConversationListComponent_ng_template_4_Template, 6, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelement(6, "jhi-alert");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.conversations.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.conversations.length !== 0);
    } }, directives: [i14.NgIf, i15.AlertComponent, i16.JhiTranslateDirective, i17.HasAnyAuthorityDirective, i14.NgForOf, i14.NgClass, i18.MatFormField, i18.MatLabel, i19.MatInput, i20.DefaultValueAccessor, i20.NgControlStatus, i20.NgModel, i14.NgStyle, i21.AutoDirectionSwitchComponent, i22.FaIconComponent, i5.RouterLink], pipes: [i14.SlicePipe, i23.FilterKeywordPipe, i10.TranslatePipe], styles: [".chat-ui-part[_ngcontent-%COMP%]{background-color:#fff;border:1px solid rgba(0,0,0,.1);border-radius:5px;margin:2px;min-height:100%;position:relative !important}.form-card[_ngcontent-%COMP%]{padding:20px 20px 0 20px;margin-bottom:0}.rating-star-hover[_ngcontent-%COMP%]{color:#44a38d}.list-group-item[_ngcontent-%COMP%]{border:none !important;padding:6px 0 !important}schedule-session[_ngcontent-%COMP%]{max-height:546px !important;overflow-y:scroll}.unread-count[_ngcontent-%COMP%]{border-radius:50%;background:#44a38b;color:#fff;width:1.5rem;height:1.5rem;margin-left:auto}.d-hidden[_ngcontent-%COMP%]{visibility:hidden}.indicator[_ngcontent-%COMP%]{width:7px;height:50px;flex:0 0 6px}[_nghost-%COMP%]  .mat-form-field-outline{color:#e1e1e1 !important}@media(min-width: 992px){.container[_ngcontent-%COMP%]{padding-bottom:96px}}@media(max-width: 992px){.container[_ngcontent-%COMP%]{padding-top:64px;padding-bottom:0}}.paginationjs[_ngcontent-%COMP%]{line-height:1.6;font-family:\"Marmelad\",\"Lucida Grande\",\"Arial\",\"Hiragino Sans GB\",Georgia,sans-serif;font-size:14px;box-sizing:initial;margin-top:4px;margin-left:25px}.paginationjs[_ngcontent-%COMP%]:after{display:table;content:\" \";clear:both}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]{float:left}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{float:left;margin:0;padding:0}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{float:left;border:1px solid #aaa;border-right:none;list-style:none}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-width:30px;height:28px;line-height:28px;display:block;background:#fff;font-size:14px;color:#333;text-decoration:none;text-align:center}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#eee}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{border:none}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{height:30px;line-height:30px;background:#aaa;color:#fff}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{opacity:.3}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{border-radius:3px 0 0 3px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child > a[_ngcontent-%COMP%]{border-radius:3px 0 0 3px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-right:1px solid #aaa;border-radius:0 3px 3px 0}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child > a[_ngcontent-%COMP%]{border-radius:0 3px 3px 0}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{float:left;margin-left:10px;font-size:14px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{width:30px;height:28px;background:#fff;border-radius:3px;border:1px solid #aaa;padding:0;font-size:14px;text-align:center;vertical-align:baseline;outline:none;box-shadow:none;box-sizing:initial}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{float:left;margin-left:10px;font-size:14px}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{min-width:40px;height:30px;line-height:28px;background:#fff;border-radius:3px;border:1px solid #aaa;text-align:center;padding:0 8px;font-size:14px;vertical-align:baseline;outline:none;box-shadow:none;color:#333;cursor:pointer}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#f8f8f8}.paginationjs[_ngcontent-%COMP%]   .paginationjs-nav[_ngcontent-%COMP%]{float:left;height:30px;line-height:30px;margin-left:10px;font-size:14px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]{font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-width:26px;height:24px;line-height:24px;font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{height:26px;line-height:26px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{width:26px;height:24px;font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{min-width:30px;height:26px;line-height:24px;padding:0 6px;font-size:12px}.paginationjs.paginationjs-small[_ngcontent-%COMP%]   .paginationjs-nav[_ngcontent-%COMP%]{height:26px;line-height:26px;font-size:12px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]{font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-width:36px;height:34px;line-height:34px;font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{height:36px;line-height:36px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{width:36px;height:34px;font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{min-width:50px;height:36px;line-height:34px;padding:0 12px;font-size:16px}.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-nav[_ngcontent-%COMP%]{height:36px;line-height:36px;font-size:16px}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#289de9}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#289de9}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#e9f4fc}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#289de9;color:#fff}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#289de9}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#289de9;border-color:#289de9;color:#fff}.paginationjs.paginationjs-theme-blue[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#3ca5ea}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#449d44}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#449d44}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#ebf4eb}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#449d44;color:#fff}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#449d44}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#449d44;border-color:#449d44;color:#fff}.paginationjs.paginationjs-theme-green[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#55a555}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#ec971f}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#ec971f}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#fdf5e9}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#ec971f;color:#fff}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#ec971f}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#ec971f;border-color:#ec971f;color:#fff}.paginationjs.paginationjs-theme-yellow[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#eea135}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-color:#c9302c}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#c9302c}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#faeaea}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#c9302c;color:#fff}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.disabled[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:none}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{border-color:#c9302c}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{background:#c9302c;border-color:#c9302c;color:#fff}.paginationjs.paginationjs-theme-red[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]:hover{background-color:#ce4541}.paginationjs[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li.paginationjs-next[_ngcontent-%COMP%]{*border-right:1px solid #aaa;border-right:1px solid}.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%]{*margin-left:5px;margin-left:5px\\0 }.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{*line-height:28px;line-height:28px\\0 ;*vertical-align:middle;vertical-align:middle\\0 }.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%]{*margin-left:5px;margin-left:5px\\0 }.paginationjs[_ngcontent-%COMP%]   .paginationjs-go-button[_ngcontent-%COMP%] > input[type=button][_ngcontent-%COMP%]{*vertical-align:middle;vertical-align:middle\\0 }.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-pages[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{line-height:36px\\0 }.paginationjs.paginationjs-big[_ngcontent-%COMP%]   .paginationjs-go-input[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{*height:35px;height:36px\\0 ;*line-height:36px;line-height:36px\\0 }"] });
